import { Injectable } from '@angular/core'
import {
  EventService,
  ProductActions,
  RoutingService,
  SearchboxService,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { SearchBoxComponentService, SearchBoxConfig } from '@spartacus/storefront'
import { BehaviorSubject, combineLatest, Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { EbSearchResults } from '../interfaces/eb-search-result.interface'

const HAS_SEARCH_RESULT_CLASS = 'has-searchbox-results'

@Injectable({
  providedIn: 'root'
})
export class EbSearchBoxComponentService extends SearchBoxComponentService {
  private ebCurrentQueryLength: number = 0
  public ebHasKeywordRedirect$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  public keywordRedirectUrl: string = ''
  constructor(
    public searchService: SearchboxService,
    protected routingService: RoutingService,
    protected translationService: TranslationService,
    protected winRef: WindowRef,
    protected eventService: EventService
  ) {
    super(searchService, routingService, translationService, winRef, eventService)
  }

  // overwritten to change return type to EbSearchResults and with this return the keywordRedirectUrl for perfect match handling
  getResults(config: SearchBoxConfig): Observable<EbSearchResults> {
    return combineLatest([
      this.getProductResults(config),
      this.getProductSuggestions(config),
      this.getSearchMessage(config)
    ]).pipe(
      map(([productResults, suggestions, message]) => {
        return {
          products: productResults ? productResults.products : null,
          suggestions,
          message,
          keywordRedirectUrl: productResults.keywordRedirectUrl || null
        }
      }),
      tap(results => this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, this.hasResults(results)))
    )
  }

  search(query: string, config: SearchBoxConfig): void {
    this.ebHasKeywordRedirect$.next(false)
    this.ebCurrentQueryLength = query ? query.length : 0
    this.searchCompleted.next(false)

    if (!this.enableRecentSearches && !this.enableTrendingSearches && (!query || query === '')) {
      this.clearResults()
      return
    }
    if (config.minCharactersBeforeRequest && query.length < config.minCharactersBeforeRequest) {
      return
    }

    let productsComplete = !config.displayProducts
    let suggestionsComplete = !config.displaySuggestions

    if (config.displayProducts) {
      this.searchService
        .searchWithCompletion(query, {
          pageSize: config.maxProducts
        })
        .subscribe((result: any) => {
          if (
            result?.type === ProductActions.SEARCH_PRODUCTS_SUCCESS &&
            result?.payload?.keywordRedirectUrl &&
            result.payload.products.length === 1
          ) {
            this.keywordRedirectUrl = result.payload.keywordRedirectUrl
            this.ebHasKeywordRedirect$.next(true)
          }
          productsComplete = true
          this.ebCheckSearchCompletion(productsComplete, suggestionsComplete)
        })
    }

    if (config.displaySuggestions) {
      this.searchService
        .searchSuggestionsWithCompletion(query, {
          pageSize: config.maxSuggestions
        })
        .subscribe((result: any) => {
          suggestionsComplete = true
          this.ebCheckSearchCompletion(productsComplete, suggestionsComplete)
        })
    }
  }
  private ebCheckSearchCompletion(productsComplete: boolean, suggestionsComplete: boolean): void {
    if (productsComplete && suggestionsComplete && this.ebCurrentQueryLength > 0) {
      this.searchCompleted.next(true)
    }
  }
}
